import { UserRoleDto } from '../services/iamapi/iamapi.services';

export class AssignRolesByUserIdRequest {
  userId: string;
  requestBody: UserRoleDto[];
}
